import Locals from '../providers/Locals';

interface ErrorReport {
    source: string;
    message: string;
    stack?: string;
    componentStack?: string;
    url: string;
    pathname?: string;
    userAgent: string;
    errorType:
        | 'onerror'
        | 'unhandledrejection'
        | 'react_boundary'
        | 'upload_failure'
        | 'workflow_action_failure'
        | 'assignment_failure';
    metadata?: Record<string, unknown>;
}

function reportError(report: ErrorReport): void {
    try {
        const token = localStorage.getItem('odo_login_token');
        if (!token) return;

        const baseUrl = Locals.config().base_api_url;
        const truncatedReport = {
            ...report,
            message: report.message.slice(0, 1000),
            stack: report.stack?.slice(0, 5000),
            componentStack: report.componentStack?.slice(0, 5000)
        };

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        fetch(`${baseUrl}/api/v1/errors`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(truncatedReport),
            keepalive: true,
            signal: controller.signal
        })
            .finally(() => clearTimeout(timeoutId))
            .catch(() => {});
    } catch {
        // Swallow all errors — error reporting must never throw
    }
}

export { reportError };
export type { ErrorReport };
